import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideRouter, withRouterConfig } from '@angular/router';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { firstValueFrom } from 'rxjs';
import { routes } from './app.routes';
import { AuthInterceptor } from '../core/auth.interceptor';
import { KeyService } from './services/key.service';
import { MY_DATE_FORMATS } from './helper/date-formats';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

const MyPreset = definePreset(Aura, {
  components: {
    checkbox: {
      root: {
        hoverBorderColor: '#307fe2',
        focusBorderColor: '#307fe2',
        checkedBackground: '#307fe2',
        checkedBorderColor: '#307fe2',
        checkedHoverBackground: '#307fe2',
        checkedHoverBorderColor: '#307fe2',
        checkedFocusBorderColor: '#307fe2'
      }
    },
    multiselect: {
      root: {
        hoverBorderColor: '#307fe2',
        focusBorderColor: '#307fe2'
      },
      option: {
        selectedBackground: '#d5e8ff',
        selectedColor: '#307fe2',
        selectedFocusBackground: '#d5e8ff',
        selectedFocusColor: '#307fe2'
      }
    },
    autocomplete: {
  root: {
    hoverBorderColor: '#307fe2',
    focusBorderColor: '#307fe2'
  },
  option: {
    focusBackground: '#d5e8ff',
    focusColor: '#307fe2',
    selectedBackground: '#d5e8ff',
    selectedColor: '#307fe2',
    selectedFocusBackground: '#d5e8ff',
    selectedFocusColor: '#307fe2'
  },
  dropdown: {
    hoverBackground: '#d5e8ff',
    hoverColor: '#307fe2'
  }
    },
    select: {
  root: {
    background: '#ffffff',
    color: '#0a0a5f',
    placeholderColor: '#666c84',
    borderColor: '#cdced5',
    hoverBorderColor: '#307fe2',
    focusBorderColor: '#307fe2'
  },
  dropdown: {
    color: '#307fe2'
  },
  overlay: {
    background: '#ffffff',
    borderColor: '#cdced5',
    color: '#0a0a5f'
  },
  option: {
    color: '#0a0a5f',
    focusBackground: '#d5e8ff',
    focusColor: '#307fe2',
    selectedBackground: '#d5e8ff',
    selectedColor: '#307fe2',
    selectedFocusBackground: '#d5e8ff',
    selectedFocusColor: '#307fe2'
  }
    },
    inputtext: {
      root: {
        hoverBorderColor: '#307fe2',
        focusBorderColor: '#307fe2'
      }
    },
    radiobutton: {
     root: {
    hoverBorderColor: '#307fe2',
    focusBorderColor: '#307fe2',
    checkedBackground: '#307fe2',
    checkedBorderColor: '#307fe2',
    checkedHoverBackground: '#307fe2',
    checkedHoverBorderColor: '#307fe2',
    checkedFocusBorderColor: '#307fe2'
    },
   icon: {
    checkedColor: '#ffffff',
    checkedHoverColor: '#ffffff'
   }
},
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    // Angular 22 changed the default to 'always'; 'emptyOnly' keeps the Angular 21 behaviour
    provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' })),
    // Angular 22 defaults HttpClient to the Fetch backend; withXhr() keeps the Angular 21 (XHR) behaviour
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },

    // replaces APP_INITIALIZER
    provideAppInitializer(() =>
      firstValueFrom(inject(KeyService).initializeToken()).catch(error => {
        console.error('Unable to initialize the application token.', error);
      })
    ),

    // PrimeNG 21 theme (replaces the old theme.css files)
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: { darkModeSelector: '.app-dark' }
      }
    }),

    provideMomentDateAdapter(MY_DATE_FORMATS),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },

    MessageService,
    KeyService,
    DatePipe
  ]
};
